export default __webpack_public_path__ + "static/media/Validate.0c063f7c.mp3";